// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import validateFavoriteRadioCodeOrRadioCode from 'validators/common/sync/radio/validateFavoriteRadioCodeOrRadioCode'

import {
  MUST_HAVE_A_CORRESPONDING_LATITUDE,
  MUST_HAVE_A_CORRESPONDING_LONGITUDE,
} from 'errors'

import {
  stringMustBeNumber,
  validateAntennaCode,
  validateLatitude,
  validateLongitude,
} from 'validators/common'

const validate = v => {
  // Since redux-form v8, first render of the form does not have the actual initial values.
  // https://github.com/redux-form/redux-form/issues/4344
  if (Object.keys(v).length === 0) {
    return
  }

  const err = {}

  err.frequency = stringMustBeNumber(v.frequency)

  // latitude/longitude validations
  validateLatitude(v.latitude, err, true)
  // if there' a longitude but no latitude, display an error
  if (!err.latitude && !v.latitude && v.longitude) {
    err.latitude = MUST_HAVE_A_CORRESPONDING_LATITUDE
  }
  validateLongitude(v.longitude, err, true)
  // if there' a latitude but no longitude, display an error
  if (!err.longitude && v.latitude && !v.longitude) {
    err.longitude = MUST_HAVE_A_CORRESPONDING_LONGITUDE
  }

  // radius stuff
  err.radius = stringMustBeNumber(v.radius)
  const radiusIsGood = v.radius && !err.radius
  if (radiusIsGood && !v.latitude) {
    err.latitude = 'Latitude Required with radius'
  }
  if (radiusIsGood && !v.longitude) {
    err.longitude = 'Longitude Required with radius'
  }

  if (v.antennaCode) {
    validateAntennaCode(v.antennaCode, err, false)
  }

  if (v.radioCode) {
    err.radioCode = validateFavoriteRadioCodeOrRadioCode(v.radioCode, false)
  }

  return err
}

export default validate
